export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS'

export const getCountriesSuccess = (value) => {
  return {
    type: GET_COUNTRIES_SUCCESS,
    data: value,
  }
}
